import { useSavedItemFolders } from 'components/SavedItems/SaveItemPopup/SavePopup';
import { store } from 'components/Store';
import { useContext, useState } from 'react';
import { useSavedItemsContext } from 'components/SavedItems/SavedItemsContext';

const SaveUpdatesToFolder = () => {
  const { state: globalState } = useContext(store);
  const { selectedUpdates } = globalState ?? {};
  const { setState } = useSavedItemsContext();

  const [isLoading, setIsLoading] = useState(false);
  const { getSavedItemFolders } = useSavedItemFolders();

  const callFoldersForUpdates = async () => {
    try {
      let folders = {};
      await Promise.all(
        selectedUpdates.map(async (item) => {
          const selectedFoldersForItem = await getSavedItemFolders({
            objectId: item?.parentObjectID ?? item?.objectID,
          });
          if (selectedFoldersForItem) {
            folders[item?.id] = selectedFoldersForItem;
          }
        })
      );
      return folders;
    } catch (error) {}
  };

  const clickFunction = async () => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        const folders = await callFoldersForUpdates();
        if (!!folders) {
          setState('showSavePopup', true);
          if (selectedUpdates?.length === 1) {
            const item = selectedUpdates[0];
            setState('savePopupItem', { ...item, savedItemsPerFolder: folders[item?.id] });
          } else {
            setState(
              'savePopupMultipleItems',
              selectedUpdates?.map((item) => {
                return { ...item, savedItemsPerFolder: folders[item?.id] };
              })
            );
          }
        }
        setIsLoading(false);
      } catch (error) {}
    }
  };

  return (
    <button className='contacts-list-bar-action-container-btn' onClick={clickFunction}>
      {isLoading ? (
        <i className='fas fa-spinner fa-spin d-inline-block-centered'></i>
      ) : (
        <span className='icon-save title-h5-m' />
      )}
      Save to a folder
    </button>
  );
};

export default SaveUpdatesToFolder;
